define("settings/controllers/groups/group/social_profiles/edit", ["exports", "@ember/controller", "@ember/object", "@ember/service", "later/utils/profile-colors", "ember-concurrency-decorators"], function (_exports, _controller, _object, _service, _profileColors, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let EditController = (_class = class EditController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "router", _descriptor5, this);

      _initializerDefineProperty(this, "segment", _descriptor6, this);

      _initializerDefineProperty(this, "store", _descriptor7, this);

      _defineProperty(this, "queryParams", ['tab']);

      _defineProperty(this, "availableColors", _profileColors.availableColors);

      _defineProperty(this, "deviceNotifyHelpVisible", false);

      _defineProperty(this, "group", null);

      _defineProperty(this, "selectedSocialProfile", null);
    }

    closeModal() {
      this.router.transitionTo('account.groups.group.social_profiles');
    }

    *saveSocialProfile(socialProfile) {
      try {
        yield socialProfile.save();
        this.alerts.clear();
        this.alerts.success(this.intl.t('alerts.linkinbio.successfully_updated'));
        this.closeModal();
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }

    addRemoveDevice(socialProfile, type, device_id) {
      const device = this.store.peekRecord('device', device_id);

      if (type === 'add') {
        this._addDeviceToProfile(socialProfile, device);
      } else if (type === 'remove') {
        this._removeDeviceFromProfile(socialProfile, device);
      }
    }

    trackChangedProfileColor(socialProfile, colorClass) {
      socialProfile.set('profileColorClass', colorClass);
      socialProfile.save().catch(adapterError => this.errors.handleAdapter(adapterError, socialProfile));
    }

    _addDeviceToProfile(profile, device) {
      profile.get('devices').addObject(device);
    }

    _removeDeviceFromProfile(profile, device) {
      profile.get('devices').removeObject(device);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveSocialProfile", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "saveSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRemoveDevice", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addRemoveDevice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangedProfileColor", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangedProfileColor"), _class.prototype)), _class);
  _exports.default = EditController;
});